/**
 * Represents a constructive concern / opportunity for a promotion packet.
 */
export interface Concern {
  id: string;
  packetId: string; // Link back to the packet
  authorId: string; // User ID of the author (can be manager, endorser, etc.)
  content: string;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * DTO for creating a concern
 */
export interface CreateConcernDTO {
  packetId: string;
  content: string;
  authorEmail: string;
}

/**
 * DTO for updating a concern
 */
export interface UpdateConcernDTO {
  content?: string;
  authorEmail?: string;
}

/**
 * Validation rules (mirrors endorsements)
 */
export const CONCERN_VALIDATION = {
  MAX_CONCERNS: 10,
  MAX_CONTENT_LENGTH: 5000,
} as const;
